export default __webpack_public_path__ + "locales/pt/ConnectDialog.json?hash=2806850b8514bcda7cfd87ebc2132ea6";